"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const OverviewComponent_1 = require("./OverviewComponent");
const DeviceTransitionContainer_1 = require("../../utils/DeviceTransitionContainer");
class OverviewContainer extends React.Component {
    render() {
        const { device } = this.props;
        return (React.createElement(DeviceTransitionContainer_1.default, { device: device },
            React.createElement(OverviewComponent_1.default, { device: device })));
    }
}
exports.default = OverviewContainer;
